var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    viewBox: "0 0 48 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2359_8351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9536 29.5337C47.9536 33.6526 44.6152 36.9926 40.4946 36.9926H0V7.50898C0 3.38883 3.3388 0.0488281 7.4594 0.0488281H47.9536V29.5337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.752 21.9797H37.8363C37.9321 21.9797 38.1154 21.9644 38.2035 21.9444C38.7968 21.8182 39.2883 21.2913 39.2883 20.574C39.2883 19.8603 38.7968 19.3322 38.2035 19.2036C38.1154 19.1848 37.9321 19.1685 37.8363 19.1685H34.752V21.9797Z",
    fill: "url(#paint0_linear_2359_8351)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4749 2.5354C34.5327 2.5354 32.1465 4.92142 32.1465 7.86428V13.3977H39.6865C39.8615 13.3977 40.0754 13.41 40.2087 13.4183C41.9151 13.5034 43.1734 14.3792 43.1734 15.9011C43.1734 17.0971 42.3134 18.118 40.7474 18.3471V18.4088C42.4773 18.5292 43.8006 19.4802 43.8006 20.9804C43.8006 22.6005 42.3474 23.6431 40.4107 23.6431H32.1465V34.5061H39.9614C42.9054 34.5061 45.2904 32.1199 45.2904 29.1777V2.5354H37.4749Z",
    fill: "url(#paint1_linear_2359_8351)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9243 16.2865C38.9243 15.5822 38.4309 15.1111 37.8517 15.0119C37.7977 15.0044 37.6495 14.989 37.5474 14.989H34.752V17.5835H37.5474C37.6495 17.5835 37.7977 17.5689 37.8517 17.5594C38.4309 17.4619 38.9243 16.9896 38.9243 16.2865Z",
    fill: "url(#paint2_linear_2359_8351)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99249 2.5354C5.04963 2.5354 2.66406 4.92142 2.66406 7.86428V21.0238C4.1591 21.7476 5.70226 22.2193 7.27294 22.2193C9.11505 22.2193 10.1283 21.0944 10.1283 19.5801V13.3977H14.7107V19.5801C14.7107 21.9984 13.2257 23.9386 8.13339 23.9386C5.06843 23.9386 2.66406 23.2766 2.66406 23.2766V34.5061H10.479C13.4218 34.5061 15.8068 32.1199 15.8068 29.1777V2.5354H7.99249Z",
    fill: "url(#paint3_linear_2359_8351)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7337 2.5354C19.7919 2.5354 17.4053 4.92142 17.4053 7.86428V14.8404C18.7558 13.6814 21.0889 12.9577 24.8824 13.1286C26.9148 13.219 29.0671 13.7637 29.0671 13.7637V16.0192C27.9892 15.4747 26.6963 14.9667 25.0316 14.8416C22.1526 14.6241 20.4211 16.0309 20.4211 18.5216C20.4211 21.0109 22.1526 22.4172 25.0316 22.1999C26.6963 22.073 28.0062 21.5544 29.0671 21.0238V23.2778C29.0671 23.2778 26.9148 23.8223 24.8824 23.9139C21.0889 24.0849 18.7558 23.3617 17.4053 22.2034V34.5061H25.2202C28.163 34.5061 30.5484 32.1199 30.5484 29.1777V2.5354H22.7337Z",
    fill: "url(#paint4_linear_2359_8351)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2359_8351",
    x1: 32.2589,
    y1: 20.574,
    x2: 45.4229,
    y2: 20.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BC46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2359_8351",
    x1: 32.2575,
    y1: 18.5204,
    x2: 45.4236,
    y2: 18.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BC46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2359_8351",
    x1: 32.2593,
    y1: 16.2865,
    x2: 45.4228,
    y2: 16.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BC46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2359_8351",
    x1: 2.77447,
    y1: 18.5204,
    x2: 15.9172,
    y2: 18.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2359_8351",
    x1: 17.5155,
    y1: 18.5204,
    x2: 30.6589,
    y2: 18.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1846"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2359_8351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 36.9925,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbIcon);
export default __webpack_public_path__ + "static/media/jcb_icon.6b72ae9122af6c0a464479289096ea15.svg";
export { ForwardRef as ReactComponent };